export enum FileImportType {
  ProductColor = 'PRODUCT_COLOR',
  ProductColorSize = 'PRODUCT_COLOR_SIZE',
  ProductColorSizeStore = 'PRODUCT_COLOR_SIZE_STORE',
  ProductColorStore = 'PRODUCT_COLOR_STORE',
  Store = 'STORE',
  StoreSeason = 'STORE_SEASON',
  StoreSeasonPermutationFields = 'STORE_SEASON_PERMUTATION_FIELDS',
}
